import { QueryClient } from "react-query";
import { IFinancialReimbursement } from "../contracts";

function deleteExceptionsUselessFields(value) {
    delete value?.a;
    delete value?.b;
    delete value?.c;
    delete value?.id;
}

function deleteUselessFields(value) {
    delete value?.type;
    delete value?.createdAt;
    delete value?.updatedAt;
    delete value?.closureType;
    delete value?.industryName;
    delete value?.industry;
}

export function getCachedIndustryData(industryName: string, queryClient: QueryClient): IFinancialReimbursement {
    const queryKeys = queryClient.getQueryCache().findAll().map(query => query.queryKey);
    const matchingQueryKey = queryKeys.find(key => key.includes('financialReimbursementData:'));
    const cachedData: any = queryClient.getQueryData(matchingQueryKey || "");
    const industryData = cachedData?.edges?.find((value) => value?.node?.industry.name === industryName);
    
    if (industryData?.node) {
        localStorage.setItem('financialReimbursementCachedData', JSON.stringify(industryData?.node));
        return industryData?.node;
    } 

    const serializedData = localStorage.getItem('financialReimbursementCachedData')
    return JSON.parse(serializedData ? serializedData : "");
}

export function checkFields(input): void {
    if (input?.closureType === "FORTWEEKLY") input.closingDay = "1 - 15 e 16 - último dia do mês";
        
    input?.exceptions?.forEach((value) => {
        if (value.closureType === "FORTWEEKLY") value.closingDay = "1 - 15 e 16 - último dia do mês";
        deleteExceptionsUselessFields(value);
    });

    deleteUselessFields(input);
}

export function getWatchValueCached() {
    const serializedData = localStorage.getItem('watchValue')
    return JSON.parse(serializedData ? serializedData : "");
}